const GradientPlusIcon = ({ width = 15, height = 16, className = "" }) => {
  return (
    <svg 
      aria-label="Plus Icon"
      role="img"
      xmlns="http://www.w3.org/2000/svg" 
      width={width} 
      height={height} 
      viewBox="0 0 15 16" 
      fill="none"
      className={className}
    >
      <g clipPath="url(#paint0_angular_6381_6441_clip_path)">
        <g transform="matrix(-0.005 0 0 -0.005 7.5 8.41528)">
          <foreignObject x="-1147.03" y="-1147.03" width="2294.05" height="2294.05">
            <div 
              style={{
                background: 'conic-gradient(from 90deg,rgba(148, 165, 249, 1) 0deg,rgba(92, 219, 246, 1) 108deg,rgba(255, 225, 117, 1) 180deg,rgba(214, 113, 246, 1) 288deg,rgba(159, 157, 249, 1) 360deg)',
                height: '100%',
                width: '100%',
                opacity: 1
              }}
            />
          </foreignObject>
        </g>
      </g>
      <path 
        d="M3.2783 9.19699H11.7217C11.934 9.19699 12.1167 9.1203 12.27 8.96691C12.4233 8.81351 12.5 8.62866 12.5 8.41233C12.5 8.19601 12.4233 8.01115 12.27 7.85776C12.1167 7.70437 11.934 7.62767 11.7217 7.62767H3.2783C3.06604 7.62767 2.88325 7.70437 2.72995 7.85776C2.57665 8.01115 2.5 8.19601 2.5 8.41233C2.5 8.62866 2.57665 8.81351 2.72995 8.96691C2.88325 9.1203 3.06604 9.19699 3.2783 9.19699ZM7.5 13.4153C7.71619 13.4153 7.90094 13.3386 8.05425 13.1852C8.20755 13.0318 8.2842 12.8489 8.2842 12.6365V4.19404C8.2842 3.98165 8.20755 3.79876 8.05425 3.64537C7.90094 3.49198 7.71619 3.41528 7.5 3.41528C7.2838 3.41528 7.09906 3.49198 6.94575 3.64537C6.79245 3.79876 6.7158 3.98165 6.7158 4.19404V12.6365C6.7158 12.8489 6.79245 13.0318 6.94575 13.1852C7.09906 13.3386 7.2838 13.4153 7.5 13.4153Z"
        fill="#5D1E6C" 
        fillOpacity="0.19"
      />
      <path 
        d="M3.2783 9.19699H11.7217C11.934 9.19699 12.1167 9.1203 12.27 8.96691C12.4233 8.81351 12.5 8.62866 12.5 8.41233C12.5 8.19601 12.4233 8.01115 12.27 7.85776C12.1167 7.70437 11.934 7.62767 11.7217 7.62767H3.2783C3.06604 7.62767 2.88325 7.70437 2.72995 7.85776C2.57665 8.01115 2.5 8.19601 2.5 8.41233C2.5 8.62866 2.57665 8.81351 2.72995 8.96691C2.88325 9.1203 3.06604 9.19699 3.2783 9.19699ZM7.5 13.4153C7.71619 13.4153 7.90094 13.3386 8.05425 13.1852C8.20755 13.0318 8.2842 12.8489 8.2842 12.6365V4.19404C8.2842 3.98165 8.20755 3.79876 8.05425 3.64537C7.90094 3.49198 7.71619 3.41528 7.5 3.41528C7.2838 3.41528 7.09906 3.49198 6.94575 3.64537C6.79245 3.79876 6.7158 3.98165 6.7158 4.19404V12.6365C6.7158 12.8489 6.79245 13.0318 6.94575 13.1852C7.09906 13.3386 7.2838 13.4153 7.5 13.4153Z" 
        fill="url(#gradient)"
      />
      <defs>
        <clipPath id="paint0_angular_6381_6441_clip_path">
          <path d="M3.2783 9.19699H11.7217C11.934 9.19699 12.1167 9.1203 12.27 8.96691C12.4233 8.81351 12.5 8.62866 12.5 8.41233C12.5 8.19601 12.4233 8.01115 12.27 7.85776C12.1167 7.70437 11.934 7.62767 11.7217 7.62767H3.2783C3.06604 7.62767 2.88325 7.70437 2.72995 7.85776C2.57665 8.01115 2.5 8.19601 2.5 8.41233C2.5 8.62866 2.57665 8.81351 2.72995 8.96691C2.88325 9.1203 3.06604 9.19699 3.2783 9.19699ZM7.5 13.4153C7.71619 13.4153 7.90094 13.3386 8.05425 13.1852C8.20755 13.0318 8.2842 12.8489 8.2842 12.6365V4.19404C8.2842 3.98165 8.20755 3.79876 8.05425 3.64537C7.90094 3.49198 7.71619 3.41528 7.5 3.41528C7.2838 3.41528 7.09906 3.49198 6.94575 3.64537C6.79245 3.79876 6.7158 3.98165 6.7158 4.19404V12.6365C6.7158 12.8489 6.79245 13.0318 6.94575 13.1852C7.09906 13.3386 7.2838 13.4153 7.5 13.4153Z"/>
        </clipPath>
        <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="rgba(148, 165, 249, 1)" />
          <stop offset="30%" stopColor="rgba(92, 219, 246, 1)" />
          <stop offset="50%" stopColor="rgba(255, 225, 117, 1)" />
          <stop offset="80%" stopColor="rgba(214, 113, 246, 1)" />
          <stop offset="100%" stopColor="rgba(159, 157, 249, 1)" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default GradientPlusIcon;